import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AnnouncementForm} from '../model/technical-installations.model';
import { Message } from '../../model/notification.model';
import { TechnicalInstallation} from '../model/technical-installations.model';

export const announceInstallation = createAction(
  '[ITECH] announce installation',
  props<{ buildingId: number; form: AnnouncementForm }>()
);
export const installationUpdateSuccess = createAction(
  '[ITECH] installation update success',
  props<{ buildingId: number; installation: TechnicalInstallation }>()
);
export const announceInstallationFailure = createAction(
  '[ITECH] announce installation failure',
  props<{ error: HttpErrorResponse; notification: Message }>()
);
export const resetActiveTechnicalInstallation = createAction('[ITECH] reset technical installation');
export const getInstallations = createAction(
  '[ITECH] fetch installations',
  props<{ buildingId: number }>()
);
export const getInstallationsSuccess = createAction(
  '[ITECH] fetch installations success',
  props<{ installations: TechnicalInstallation[] }>()
);
export const getInstallationsFailure = createAction(
  '[ITECH] fetch installations failure',
  props<{ error: HttpErrorResponse; notification: Message }>()
);
export const updateAnnouncement = createAction(
  '[ITECH] update installation announcement',
  props<{ installationId: number; form: TechnicalInstallation; buildingId: number }>()
);
